'use strict';

/*
 * @Author: your name
 * @Date: 2021-04-14 09:20:19
 * @LastEditTime: 2021-04-14 09:42:11
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \vip-h5-sd\config.js
 */
var config = {
  development: {
    // domain: 'http://127.0.0.1:9090',
    // api: 'http://192.168.0.101:20589/memberapi',
    // // appid
    // appid: 'wx3857fb25059205c9',
    // // 订单过期时间，精确到秒
    // orderMaxAge: 30 * 60,
    domain: 'https://member-m.sdhlxh.com',
    api: 'https://meet-m.sdhlxh.com/memberapi',
    // appid
    appid: 'wx6ae15770c1d3431d',
    // 订单过期时间，精确到秒
    orderMaxAge: 30 * 60
  },
  production: {
    domain: 'https://member-m.sdhlxh.com',
    api: 'https://meet-m.sdhlxh.com/memberapi',
    // appid
    appid: 'wx6ae15770c1d3431d',
    // 订单过期时间，精确到秒
    orderMaxAge: 30 * 60
  }
};

module.exports = Object.assign({
  version: '1.0.0',
  port: 9090,
  authUrl: 'https://open.weixin.qq.com/connect/oauth2/authorize',
  jsname: 'vip-index.js'
}, config[process.env.WEB_ENV || 'development']);


//////////////////
// WEBPACK FOOTER
// ./config.js
// module id = 103
// module chunks = 14